import moment from 'moment';
import { appConstants } from './app-constants';
import { ExamFormData } from './exam.types';

/**
 * Edit exam DTO
 */
export class ExamInfoUpdatePayload {
  internalPatientId: number;
  patientId: number;
  userName: string;
  updated: ExamInfo;
  original: ExamInfo;

  constructor(internalPatientId: number, patientId: number, userName: string, updated: ExamInfo, original: ExamInfo) {
    this.internalPatientId = internalPatientId;
    this.patientId = patientId;
    this.userName = userName;
    this.updated = updated;
    this.original = original;
  }
}

/**
 * Exam Info
 */
export class ExamInfo {
  internalExamId?: number;
  internalPatientId?: number;
  patientCkey?: number;
  studyDateTime?: string;
  scheduledStudyDateTime?: string;
  internalPriorityId?: number;
  clinicalComments?: string;
  orderNumber?: string;
  internalProcedureId?: number;
  accessionNumber?: string;
  internalPerformingPhysicianId?: number;
  internalReferringPhysicianId?: number;
  orderingLocationId?: number;
  internalDepartmentId?: number;
  userName: string;

  constructor(examFormData: ExamFormData, internalExamId: number) {
    this.studyDateTime = examFormData.studyDate
      ? moment(examFormData.studyDate)
          .hour(examFormData.studyTime ? examFormData.studyTime.hours() : 0)
          .minute(examFormData.studyTime ? examFormData.studyTime.minutes() : 0)
          .format(appConstants.format.dateTimeSec)
      : '';
    this.scheduledStudyDateTime = examFormData.scheduledDate
      ? moment(examFormData.scheduledDate)
          .hour(examFormData.scheduledTime ? examFormData.scheduledTime.hours() : 0)
          .minute(examFormData.scheduledTime ? examFormData.scheduledTime.minutes() : 0)
          .format(appConstants.format.dateTimeSec)
      : '';
    this.internalPriorityId = examFormData.priority.internalPriorityId;
    this.clinicalComments = examFormData.clinicalComments;
    this.orderNumber = examFormData.orderNumber ? examFormData.orderNumber : null;
    this.internalProcedureId = examFormData.procedureDescription.internalProcedureId;
    this.accessionNumber = examFormData.accessionNumber;
    this.internalPerformingPhysicianId = examFormData.performingPhysician
      ? examFormData.performingPhysician.internalStid
      : null;
    this.internalReferringPhysicianId = examFormData.referringPhysician
      ? examFormData.referringPhysician.internalStid
      : null;
    this.orderingLocationId = examFormData.orderingLocation.orderingLocationId;
    this.internalDepartmentId = examFormData.departmentName.internalDepartmentId;
    this.internalExamId = internalExamId;
  }
}
